import { createSlice } from '@reduxjs/toolkit'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'
import { isNullOrUndefined } from 'utils'

export const fetchTalkChannels = createAxiosThunk(
  'talkChannelRegister/fetchTalkChannels',
  () => api.channel.getTalkChannels()
)

const initialState = {
  bizChannelId: null,
  isLoading: false,
  accountTalkChannels: [],
}

export const mapTalkChannels = createAxiosThunk(
  'talkChannelRegister/mapTalkChannels',
  (noArgs, { getState }) => {
    const {
      talkChannelRegister: { bizChannelId, accountTalkChannels },
    } = getState()
    return api.channel.mapTalkChannels({
      bizChannelId,
      uuids: accountTalkChannels
        .filter(channel => channel.isSelected)
        .map(channel => channel.uuid),
    })
  }
)

const talkChannelRegisterSlice = createSlice({
  name: 'talkChannelRegister',
  initialState,

  reducers: {
    reset: () => initialState,
    setBizChannelId: (state, { payload: bizChannelId }) => {
      state.bizChannelId = bizChannelId
    },
    toggleAccountTalkChannel: ({ accountTalkChannels }, { payload: uuid }) => {
      const kakaoTalkChannel = accountTalkChannels.find(
        channel => channel.uuid === uuid
      )
      if (!isNullOrUndefined(kakaoTalkChannel))
        kakaoTalkChannel.isSelected = !kakaoTalkChannel.isSelected
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchTalkChannels.pending, state => {
      state.isLoading = true
    })

    builder.addCase(fetchTalkChannels.fulfilled, (state, { payload }) => {
      state.accountTalkChannels = payload
        .map(({ uuid, profileImage, name }) => ({
          uuid,
          name,
          imgURL: profileImage.smallUrl.replace(/^https?:/, ''),
          isSelected: false,
        }))
        .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
      state.isLoading = false
    })

    builder.addCase(fetchTalkChannels.rejected, state => {
      state.isLoading = false
    })

    builder.addCase(mapTalkChannels.pending, state => {
      state.isLoading = true
    })

    builder.addCase(mapTalkChannels.fulfilled, state => {
      state.isLoading = false
    })

    builder.addCase(mapTalkChannels.rejected, state => {
      state.isLoading = false
    })
  },
})

export const { reset, toggleAccountTalkChannel, setBizChannelId } =
  talkChannelRegisterSlice.actions

export default talkChannelRegisterSlice.reducer
